import React, { useState } from "react";
import "../../Styles/Modal.css";
import { ImCancelCircle } from "react-icons/im";

const Renew = ({ handleRenew }: any) => {
  const [showCategoryInput, setShowCategoryInput] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setSelectedOption(value);
    setShowCategoryInput(true);
  };

  const handleRenewClick = () => {

    setSelectedOption("");
    setShowCategoryInput(false);
  };

  return (
    <div className="modal">
      <div className="catModal">
        <div className="catModalTop">
          <h4>Renew Subscription</h4>
          <ImCancelCircle className="catCancel" onClick={handleRenew} />
        </div>
        <div className="line"></div>

        <div className="RenewModalInput">
          <span>
            Diamond Plan
            <input
              type="radio"
              name="plan"
              value="diamond"
              checked={selectedOption === "diamond"}
              onChange={handleRadioChange}
            />
          </span>
          <span>
            Basic Plan
            <input
              type="radio"
              name="plan"
              value="basic"
              checked={selectedOption === "basic"}
              onChange={handleRadioChange}
            />
          </span>
          <span>
            Standard Plan
            <input
              type="radio"
              name="plan"
              value="standard"
              checked={selectedOption === "standard"}
              onChange={handleRadioChange}
            />
          </span>
          <span>
            Standard Pro Plan
            <input
              type="radio"
              name="plan"
              value="standardPro"
              checked={selectedOption === "standardPro"}
              onChange={handleRadioChange}
            />
          </span>
          <span>
            Gold Plan
            <input
              type="radio"
              name="plan"
              value="gold"
              checked={selectedOption === "gold"}
              onChange={handleRadioChange}
            />
          </span>
        </div>

        {showCategoryInput && (
          <div className="catModalInput">
            <label>Number of Months </label>
            <input type="text" placeholder="E.g: 2" />
          </div>
        )}

        <div className="catModalBtn">
          <button className="catBtn1" onClick={handleRenewClick}>
            Renew
          </button>
          <button className="catBtn2" onClick={handleRenew}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default Renew;
